// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************************************
 * FileName      : main.css
 * Description   : ketri-portal 카드 선택 화면 스타일 (KETRI 라이트 테마)
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.04.27
 * Modified Date : 2026.04.28 라이트 테마 + 컴팩트 카드 그리드로 전면 개편
 ***************************************************************************************/

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  font-family: 'Pretendard', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: #f8fafc;
  color: #0f172a;
  -webkit-font-smoothing: antialiased;
}

.portal {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 24px 24px;
}

.portal__header {
  margin-bottom: 28px;
}

.portal__brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.portal__brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: #ffffff;
  background: #1e3a8a;
  padding: 5px 10px;
  border-radius: 4px;
}

.portal__brand-name {
  font-size: 13px;
  font-weight: 700;
  color: #1e3a8a;
  letter-spacing: -0.2px;
}

.portal__title {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin: 0 0 6px;
  color: #0f172a;
}

.portal__lead {
  font-size: 13.5px;
  line-height: 1.6;
  color: #475569;
  margin: 0;
  max-width: 720px;
}

.portal__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
  align-content: start;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 18px 18px 14px 22px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--card-accent, #1e3a8a);
  border-radius: 8px 0 0 8px;
}

.card:hover {
  border-color: var(--card-accent, #1e3a8a);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.card__badge {
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 2px 7px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #64748b;
  letter-spacing: 0.6px;
}

.card__subtitle {
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--card-accent, #1e3a8a);
  margin: 0 0 4px;
}

.card__title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
  letter-spacing: -0.2px;
}

.card__description {
  font-size: 12.5px;
  line-height: 1.55;
  color: #64748b;
  margin: 0 0 14px;
  flex: 1;
}

.card__action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--card-accent, #1e3a8a);
}

.card__action::after {
  content: '→';
  transition: transform 0.15s ease;
}

.card:hover .card__action::after {
  transform: translateX(2px);
}

.portal__footer {
  margin-top: auto;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
  font-size: 12px;
  color: #94a3b8;
}

/* ============== Embed view (iframe) ============== */
/* 2026.04.28 : 매터포트 viewport 를 최대로 확보하기 위해 헤더바를 제거하고
   좌상단에 floating pill 형태의 작은 컨트롤만 배치. iframe 은 100vw × 100vh. */

.embed {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: #0f172a;
  overflow: hidden;
}

.embed__frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;;;;;;wFAMwF;;AAExF;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,6FAA6F;EAC7F,mBAAmB;EACnB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA,sDAAsD;AACtD;+DAC+D;;AAE/D;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;AAChB","sourcesContent":["/***************************************************************************************\n * FileName      : main.css\n * Description   : ketri-portal 카드 선택 화면 스타일 (KETRI 라이트 테마)\n * Author        : (주)한국공학기술연구원 박은정\n * Created Date  : 2026.04.27\n * Modified Date : 2026.04.28 라이트 테마 + 컴팩트 카드 그리드로 전면 개편\n ***************************************************************************************/\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  font-family: 'Pretendard', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  background: #f8fafc;\n  color: #0f172a;\n  -webkit-font-smoothing: antialiased;\n}\n\n.portal {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 40px 24px 24px;\n}\n\n.portal__header {\n  margin-bottom: 28px;\n}\n\n.portal__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.portal__brand-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 1.5px;\n  color: #ffffff;\n  background: #1e3a8a;\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.portal__brand-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e3a8a;\n  letter-spacing: -0.2px;\n}\n\n.portal__title {\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  margin: 0 0 6px;\n  color: #0f172a;\n}\n\n.portal__lead {\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: #475569;\n  margin: 0;\n  max-width: 720px;\n}\n\n.portal__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 14px;\n  align-content: start;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 18px 18px 14px 22px;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.card::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--card-accent, #1e3a8a);\n  border-radius: 8px 0 0 8px;\n}\n\n.card:hover {\n  border-color: var(--card-accent, #1e3a8a);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);\n  transform: translateY(-1px);\n}\n\n.card__badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding: 2px 7px;\n  border-radius: 4px;\n  background: #f1f5f9;\n  color: #64748b;\n  letter-spacing: 0.6px;\n}\n\n.card__subtitle {\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--card-accent, #1e3a8a);\n  margin: 0 0 4px;\n}\n\n.card__title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 6px;\n  letter-spacing: -0.2px;\n}\n\n.card__description {\n  font-size: 12.5px;\n  line-height: 1.55;\n  color: #64748b;\n  margin: 0 0 14px;\n  flex: 1;\n}\n\n.card__action {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--card-accent, #1e3a8a);\n}\n\n.card__action::after {\n  content: '→';\n  transition: transform 0.15s ease;\n}\n\n.card:hover .card__action::after {\n  transform: translateX(2px);\n}\n\n.portal__footer {\n  margin-top: auto;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n/* ============== Embed view (iframe) ============== */\n/* 2026.04.28 : 매터포트 viewport 를 최대로 확보하기 위해 헤더바를 제거하고\n   좌상단에 floating pill 형태의 작은 컨트롤만 배치. iframe 은 100vw × 100vh. */\n\n.embed {\n  position: relative;\n  width: 100vw;\n  height: 100vh;\n  background: #0f172a;\n  overflow: hidden;\n}\n\n.embed__frame {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
